interface Props {
  children: React.ReactNode | React.ReactNode[]
  [props: string]: any
}

const NoSSR = ({ children, ...props }: Props) => (
  <div suppressHydrationWarning {...props}>
    {typeof window === 'undefined' ? null : children}
  </div>
)

export default NoSSR
